import { render, staticRenderFns } from "./invoicetransfer.vue?vue&type=template&id=341bdfd3&"
import script from "./invoicetransfer.vue?vue&type=script&lang=js&"
export * from "./invoicetransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports